<template>
  <div>
    <div class="footbar wrap">
      <span class="ft_title">友情链接：</span>
      <a href="https://www.grg.cn/pc/sy/index.shtml" target="_blank">无线电集团</a>
      <a href="https://grgtest.com/" target="_blank">广电计量</a>
      <a href="https://www.grgbanking.com/cn/about/friend.html?tdsourcetag=s_pcqq_aiomsg" target="_blank">广电运通</a>
      <a href="http://www.haige.com/cn/index.html" target="_blank">海格通信</a>
      <a href="http://www.grguser.com/index.html" target="_blank">广电城市服务</a>
      <a href="https://grgtest.com/" target="_blank">广电智能</a>
      <a href="https://grgtest.com/" target="_blank">平云资本</a>
    </div>
    <div class="foot_Wrap">
      <div class="footer">
        <div class="wrap">
          <p class="about_wrap">
            <span class="link_a" @click.stop="toAboutUs">关于我们</span>
            <span class="link_a">法律声明</span>
            <span class="link_a" @click.stop="toAboutUs('contact')">联系我们</span>
            <span>投诉咨询：4006020999</span>
          </p>
          <p>
            <span>©</span>
            广电计量检测集团股份有限公司 版权所有 <a href="http://beian.miit.gov.cn" rel="nofollow" target="_blank">粤ICP备11014689号-11</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {},
  methods: {
    toAboutUs(type) {
      console.log(type)
      if (type == 'contact') {
        this.$router.push({
          name: 'aboutUs',
          query: { UrlName: 'Contact' }
        })
      } else {
        this.$router.push({
          name: 'aboutUs'
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.footbar {
  text-indent: 2em;
  height: 40px;
  line-height: 40px;
  background: #d8eafa;
  margin-bottom: 15px;
  .ft_title {
    color: #0774c5;
    font-weight: bold;
  }
  a {
    color: #666666;
    text-decoration: none;
    margin: 0 13px;
  }
}
.footer {
  padding: 40px 0;
  background: #054c81;
  color: #fff;
  text-align: center;
  width: 100%;
  .about_wrap {
    margin-bottom: 15px;
    .link_a {
      cursor: pointer;
      position: relative;
      padding-right: 15px;
      margin-left: 15px;
    }
    .link_a:nth-of-type(3) {
      margin-right: 15px;
    }
    .link_a:after {
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 100%;
      background: #fff;
      display: block;
      content: '';
      clear: both;
    }
  }
}
</style>
